'use client'
import {
  RICHTEXT_QUERY
} from "./chunk-G62SUGCR.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/qaList.ts
var QA_QUERY = `
id
title
description{${RICHTEXT_QUERY}}
renderType
labelAlignment
descriptionPosition
qaListCollection{
  items {
    title
    description{json}
    icon{${IMAGE_QUERY}}
    iconType
  }
}
`;

export {
  QA_QUERY
};
//# sourceMappingURL=chunk-E2IPB3JC.mjs.map